"use client";
import React from "react";
import { FaPhone } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa";
import { FaFacebook, FaXTwitter, FaYoutube, FaSquareInstagram } from "react-icons/fa6";
import { BiPhoneCall } from "react-icons/bi";

import "./TopHeader.css";
const TopHeader = () => {
  // const handleClick = (e) => {
  //   e.preventDefault();
  // };
  return (
    <>
      <div className='header-top d-none d-lg-block'>
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-md-6 d-flex flex-wrap align-items-center'>
              <div className="d-flex align-items-center me-1">
                <i className="fas fa-phone-alt me-2 text-primary"></i>
                <a href="tel:+918544015151" className="text-white text-decoration-none css-topheader-font"><FaPhone /> +918544015151</a>
              </div>
              <div className="vr mx-2 d-none d-md-block"></div>
              <div className="d-flex align-items-center">
                <i className="fas fa-envelope me-2 text-primary"></i>
                <a href="mailto:info@aarogyamhdna.com" className="text-white text-decoration-none css-topheader-font"><FaEnvelope /> info@aarogyamhdna.com</a>
              </div>
            </div>
            <div className='col-md-6 d-flex justify-content-md-end justify-content-start align-items-center mt-2 mt-md-0 css-social-media-icons'>
              <a href="https://www.facebook.com/HDNAAarogyamHospital/" className="me-1 social-links" target='_blank' aria-label="Facebook"><FaFacebook /></a>
              <a href="https://www.instagram.com/hdna_aarogyam_hospital/" className="me-1 social-links" target='_blank' aria-label="Instagram"><FaSquareInstagram /></a>
              <a href="https://x.com/HDNAAarogyam" className="me-1 social-links" target='_blank' aria-label="Twitter"><FaXTwitter /></a>
              <a href="https://www.youtube.com/@HDNAAarogyamHospitalPatna" className="me-1 social-links" target='_blank' aria-label="Youtube"><FaYoutube /></a>
              <a href="tel:+918544015151" className="d-flex align-items-center css-appointment-btn">
                <BiPhoneCall className='css-fs-call-icon' /> Schedule Appointment
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;
